import {RestAPI} from '@/constants/routeAPI';

import axiosMethods from './apiManager';

export const getFactoryDefaultReturnValvePressure = async () => {
  const response = await axiosMethods.get(RestAPI.FACTORY_DEFAULT_RETURN_VALVE_PRESSURE, null, true, true);
  return response;
};

export const getDefaultReturnValvePressure = async () => {
  const response = await axiosMethods.get(RestAPI.DEFAULT_RETURN_VALVE_PRESSURE, null, true, true);
  return response;
};

export const getUpdateReturnValvePressure = async () => {
  const response = await axiosMethods.get(RestAPI.UPDATE_RETURN_VALVE_PRESSURE, null, true, true);
  return response;
};
